module.exports = __webpack_public_path__ + "img/deansel_logo_white.baf0f024.png";